import { useState } from 'react';
import { faqs } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  const faqJson = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <section id="faq" className="bg-background-100/60 scroll-mt-24">
      <div className="mx-auto max-w-4xl px-4 py-14 md:px-6 md:py-20">
        <script type="application/ld+json">{JSON.stringify(faqJson)}</script>
        <SectionHeading
          kicker="常见问答 FAQ"
          title="关于早报，你可能想问"
          desc="我们整理了读者最常问到的几个问题，如果还有疑惑，欢迎通过页面底部邮箱与我们联系。"
          align="center"
        />

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border bg-background-50 transition-colors ${
                  isOpen ? 'border-primary-300 ring-1 ring-primary-100' : 'border-background-200'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="flex items-center gap-3 font-heading text-base font-bold text-foreground-950">
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-black ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-900'
                      }`}
                    >
                      Q
                    </span>
                    {f.q}
                  </span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-900'
                    }`}
                  >
                    <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} h-4 w-4`} />
                  </span>
                </button>
                {isOpen ? (
                  <div className="border-t border-background-100 px-5 py-4">
                    <p className="flex gap-3 text-sm leading-relaxed text-foreground-600">
                      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-100 text-xs font-bold text-accent-900">
                        A
                      </span>
                      {f.a}
                    </p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}